export default __webpack_public_path__ + "static/media/page38.5994d4f4.jpg";